import React, { Component } from 'react';
import styled from 'styled-components';

import Layout from '../components/PageLayout';
import Seo from '../components/seo';

const Container = styled.div`
  text-align: center;
  padding: 95px 16px;
`;

export default class NotFoundPage extends Component {
  render() {
    return (
      <Layout>
        <Seo title="404: Not found" description="This page doesn't exist" />
        <Container>
          <span
            css={`
              font-size: 10rem;
              margin: 5vmin 0;
              display: block;
            `}
            role="img"
            aria-label="facepalm emoji"
          >
            🤦‍♀️
          </span>
          <h1>This page doesn't exist</h1>
          <h4>Are you looking for a couple?</h4>
          <p>
            <a href="/find">Search for them here</a> or go{' '}
            <a href="/">back to the homepage</a>.
          </p>
          <h4>Are you looking for your own website?</h4>
          <p>
            Make sure your website is active in your{' '}
            <a href="/admin/website-settings">settings</a>, and allow up to 20
            minutes for it to become live.
          </p>
        </Container>
      </Layout>
    );
  }
}
